export default "__VITE_ASSET__BUgIh4XY__"